import { useCallback, useEffect, useRef, useState } from "react";
import { DashboardOutlined, LineChartOutlined, PlayCircleOutlined, StopOutlined } from "@ant-design/icons"
import { Flex, Spin, Table, Tabs, Typography, notification, theme } from "antd"
import { runDynamo } from "../dynamo";
import { ACELERACION_GRAVEDAD, EVENT_BLE, maxDuracionPruebaSegundos } from "../../../../../Constantes";
import ReactECharts from 'echarts-for-react';
import useBle from "../../../../../Hooks/Ble";
import useSimulacionBle from "../../../../../Hooks/useSimulacionBle";
import useRegistroRep from "../../../../../Hooks/useRegistroRep";
const { useToken } = theme;


const Grafica = ({ opciones_grafica }) => {
    return <div style={{ height: 600 }}>
        <ReactECharts lazyUpdate={true} theme={'dark2'} option={opciones_grafica} style={{ width: '100%', height: '100%' }} />
    </div>
}



const Rep = ({ atleta, repKey }) => {
    const [seed, setSeed] = useState(null)
    const { token } = useToken()
 
    const datos_brutos = useRef([])
    const [fases, setFases] = useState([])
    const [parametros, setParametros] = useState([])
    const [frames, setFrames] = useState([])
    const [cargando_frames, setCargandoFrames] = useState(false)
    const [sistema_de_pesos_y_tiempos, setSistemaDePesoTiempo] = useState([])
    const sistemaRef = useRef([])
    const [grabando, setGrabando] = useState(false)
    const ref_grabando = useRef(false)
    const maxDuracionSeg = maxDuracionPruebaSegundos(atleta)
    const maxDuracionRef = useRef(maxDuracionSeg)
    maxDuracionRef.current = maxDuracionSeg
    const autoStopMaxDuracionRef = useRef(false)
    const detenerRef = useRef(() => Promise.resolve())
    const [url_video, setURLVideo] = useState(null)
    const [tabActivo, setTabActivo] = useState("1")

    const tiempo_inicio_grabacion = useRef(null)

    const { resetearBalanza } = useBle()
    useSimulacionBle({
        grabando,
        ref_grabando,
        tipo: "dynamo",
        duracionSimulacionSegundos: maxDuracionSeg,
    })

    const tiempo_inicio = useRef(0)

    const getSnapshot = useCallback(
        () => ({
            sistema_de_pesos_y_tiempos,
            fases,
            parametros,
            datos: null,
            datos_brutos: [...datos_brutos.current],
        }),
        [sistema_de_pesos_y_tiempos, fases, parametros]
    );

    const hasDatosRep = useCallback(
        () => Array.isArray(sistema_de_pesos_y_tiempos) && sistema_de_pesos_y_tiempos.length > 0,
        [sistema_de_pesos_y_tiempos]
    );

    useRegistroRep(repKey, getSnapshot, hasDatosRep);

    const opciones_grafica = {
        type: 'line',
        legend: {

        },
        tooltip: {
            trigger: 'none',
            axisPointer: {
                type: 'cross'
            }
        },
        xAxis: {
            type: 'category',
            name: 'Tiempo (s)',
            nameLocation: 'middle',
            axisLabel: {
                formatter: '{value}',
                align: 'center'
            },
            data: sistema_de_pesos_y_tiempos.map(s => (s?.tiempo ?? 0).toFixed(1)),
        },
        yAxis: {
            type: 'value',
            name: 'Fuerza (N)',
            boundaryGap: [0, '30%'],
            nameLocation: 'middle',
            nameGap: 50
        },
        series: [
            {
                name: 'Valor',
                type: 'line',
                backgroundColor: '#F39C12',
                data: sistema_de_pesos_y_tiempos.map(d => d?.peso?.combinada ?? 0),
                markArea: {
                    itemStyle: {
                        opacity: .5,

                    },
                    label: {
                        rotate: 45,
                        position: 'insideTopLeft',
                        color: 'whitesmoke'
                    },
                    data: fases
                        .filter((f) => typeof f.fin === "number" && f.fin >= f.inicio && f.inicio >= 0)
                        .map((f) => ([
                        {
                            name: f.nombre,
                            xAxis: f.inicio,
                            itemStyle: {
                                color: f.color,
                                opacity: .5
                            }
                        },
                        {
                            xAxis: f.fin
                        }
                    ]))

                }
            }
        ]
    }

   
    function onBle({ detail }) {

        if (detail.length && ref_grabando.current === true) {
            console.log('Ble...')
            setSistemaDePesoTiempo(prev => {
                const dato = detail
                datos_brutos.current.push([dato[0], dato[1]].join(" "))
                const tiempo_anterior = prev.length ? prev[prev.length - 1].anterior : 0
                const acomulado = prev.length ? prev[prev.length - 1].tiempo : 0
                const tiempo_transcurrido = prev.length ? parseFloat(dato[1]) - tiempo_anterior : 0
                const siguiente = {
                    anterior: parseFloat(dato[1]),
                    tiempo: tiempo_transcurrido + acomulado,
                    masa: {
                        combinada: parseFloat(dato[0])
                    },
                    peso: {
                        combinada: parseFloat(dato[0]) * ACELERACION_GRAVEDAD,
                    }
                }
                const next = [...prev, siguiente]
                sistemaRef.current = next
                if (siguiente.tiempo >= maxDuracionRef.current && !autoStopMaxDuracionRef.current) {
                    autoStopMaxDuracionRef.current = true
                    setTimeout(() => {
                        void detenerRef.current?.()
                    }, 0)
                }
                return next
            })
        }
    }

    const iniciar = async () => {
        autoStopMaxDuracionRef.current = false
        setFases([])
        setFrames([])
        setSistemaDePesoTiempo([])
        sistemaRef.current = []
        setTabActivo("1")
        //video_blob.current = []
        datos_brutos.current = []
        await resetearBalanza()
    
        
        setGrabando(true)
        ref_grabando.current = true



    }

    async function detener() {
        setGrabando(false)
        ref_grabando.current = false
        await esperar(350)

        try {
            await calcularParametros()
        } catch (error) {
            notification.error({ description: 'Descarte la prueba no se obtuvieron datos validos' })
        }
    }

    const esperar = (t) => {
        return new Promise((resolve) => setTimeout(resolve, t))
    }

    const calcularParametros = async () => {
        try {
            setCargandoFrames(true)
            const datos = sistemaRef.current.length ? sistemaRef.current : sistema_de_pesos_y_tiempos
            if (!datos.length) {
                throw new Error("Sin datos para calcular")
            }
            const { fases: fases_calculadas, parametros: parametros_calculados } = await runDynamo(datos)
            setParametros(parametros_calculados)
            setFases(fases_calculadas)
            notification.success({ description: "Parámetros calculados" })
        } catch (err) {
            console.log(err)
            notification.error({ description: err?.message || err.toString() })
        } finally {
            setCargandoFrames(false)
        }
    }

    detenerRef.current = detener

    const tabs = [
        {
            label: "Gráfica",
            key: "1",
            icon: <LineChartOutlined />,
            children: <Grafica opciones_grafica={opciones_grafica} />
        },
        {
            label: "Parámetros",
            key: "2",
            icon: <DashboardOutlined />,
            children: (
                <div style={{ paddingRight: 16, paddingTop: 16, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                    <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}>
                        <Table
                            dataSource={parametros}
                            pagination={false}
                            size="small"
                            tableLayout="fixed"
                            rowKey={(row, index) => `${row?.nombre ?? "p"}-${index}`}
                            scroll={{ x: 640, y: 480 }}
                            style={{ width: "100%" }}
                        >
                            <Table.Column title="Parámetro" dataIndex="nombre" ellipsis width={280} />
                            <Table.Column
                                title="Valor"
                                dataIndex="valor"
                                width={200}
                                render={(v, record) => {
                                    const n = Number(v)
                                    const cuerpo = Number.isFinite(n) ? n.toFixed(2) : (v == null || v === "" ? "" : String(v))
                                    return (
                                        <Typography.Text style={{ wordBreak: "break-word" }}>
                                            {cuerpo}{record.u ? ` ${record.u}` : ""}
                                        </Typography.Text>
                                    )
                                }}
                            />
                        </Table>
                    </div>
                </div>
            )
        }
    ]

    useEffect(() => {
        setSeed(Date.now())
        document.addEventListener(EVENT_BLE, onBle)

        return () => {
            console.log("remover e")
            document.removeEventListener(EVENT_BLE, onBle)
        }
    }, [])


    return <>
        <Flex justify="space-between" style={{ flex: 1, minWidth: 0, width: "100%" }} >
            <div style={{ flex: 1, minWidth: 0, maxWidth: "100%", overflow: "hidden" }}>
                <Tabs
                    style={{ flex: 1 }}
                    tabPosition="left"
                    items={tabs}
                    activeKey={tabActivo}
                    onChange={setTabActivo}
                />
            </div>

            <Flex style={{ width: "30%" }} vertical justify="flex-start">
                <br></br>
                <Flex vertical align="center">
                    {!grabando && !sistema_de_pesos_y_tiempos.length ? <Flex vertical gap="middle" align="center">
                        <PlayCircleOutlined style={{ fontSize: 72, color: token.colorPrimary }} onClick={iniciar} />
                        <Typography.Text style={{ textAlign: 'center' }}>Iniciar prueba</Typography.Text>
                    </Flex> : null}

                    {grabando ? <Flex vertical gap="middle" align="center">
                        <StopOutlined style={{ fontSize: 72, color: token.colorPrimary }} onClick={detener} />
                        <Typography.Text style={{ textAlign: 'center' }}>Detener prueba</Typography.Text>
                    </Flex> : null}

                    {cargando_frames ? <Spin spinning={true}><Typography.Text>Calculando parametros</Typography.Text></Spin> : null}
                </Flex>
            </Flex>
        </Flex>
    </>
}

export default Rep